import ChangeTypeModal from './ChangeTypeModal';

export default ChangeTypeModal;
